/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')
import './plugins/checkVersionApp'
import './plugins/setUserToken'
import versionService from './services/versionService'

import Vue from 'vue'
import { BootstrapVue, IconsPlugin, LayoutPlugin, ModalPlugin, CardPlugin, VBScrollspyPlugin, DropdownPlugin, TablePlugin } from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import VueRouter from 'vue-router'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import VueMask from 'v-mask'
import VueMeta from 'vue-meta'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(TablePlugin)
Vue.use(VueSweetalert2)
Vue.use(VBScrollspyPlugin)
Vue.use(VueRouter)
Vue.use(VueMask, {   // (!) custom placeholders support requires registration as a plugin to
    placeholders: {
        Я: /[\wА-Я]/,
    }
})
Vue.use(VueMeta)
Vue.use(VueBootstrapTypeahead)

import '@/plugins/Toast'
import './api/index'
// import './plugins/directives'
import Api from './services/api'
// import Auth from './services/auth'
import store from "./store"
import routes from './router'
import Multiselect from 'vue-multiselect'

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import VueMq from 'vue-mq'
Vue.use(VueMq, {
    breakpoints: {
        sm: 768,
        md: 991,
        lg: 1200,
        xl: Infinity,
    }
})

window.api = new Api()
// window.auth = new Auth()
window.App = new Vue // Global event manager in VUE instance

const moment = require('moment')
require('moment/locale/ru')

Vue.use(require('vue-moment'), {
    moment
})

Vue.prototype.moment = moment

Vue.component('vue-app', require('./views/App.vue').default)
Vue.component('tsoft-table', require('./components/tables/Table.vue').default)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

// Selectors
Vue.component('multiselect', Multiselect)
Vue.component('tsoft-select-of-properties', require('./components/references/SelectOfPropertiesByReference.vue').default)
Vue.component('tsoft-select-of-airports', require('./components/references/SelectOfAirports.vue').default)
Vue.component('tsoft-select-user', require('./components/references/SelectOfUsersByRole.vue').default)
Vue.component('tsoft-select-company', require('./components/companies/SelectOfCompanyBySearchLine.vue').default)

// Documents
Vue.component('tsoft-create-documents', require('./components/documents/CreateDocuments.vue').default)
Vue.component('tsoft-show-edit-documents', require('./components/documents/ShowOrEditDocuments.vue').default)
Vue.component('tsoft-show-edit-documents-client', require('./components/documents/ShowOrEditDocumentsClient.vue').default)
Vue.component('tsoft-upload-area', require('./components/documents/FilesUploadArea.vue').default)

// Tasks
Vue.component('tsoft-history-task', require('./components/task/HistoryTask.vue').default)

// ContextMenus
Vue.component('tsoft-context-menu-headers', require('./components/contextmenu/ContextMenuHeaders.vue').default)

// Design
Vue.component('tsoft-wrapper', require('./components/wrapper/Wrapper.vue').default)

// Update notification
Vue.component('update-notification', require('./components/common/UpdateNotification.vue').default)

Vue.component('v-mask', VueMask)

Vue.filter('formattedNamedDate', function (date) {
    let formatDate = moment(date, 'DD.MM.YYYY').format('MMMM YYYY')

    if (formatDate == 'Invalid date') return "Не указана"
    return formatDate
})
Vue.filter('formattedDate', function (date) {
    let formatDate = moment(date).format('DD.MM.YYYY')

    if (formatDate == 'Invalid date') return "Не указана"
    return formatDate
})
Vue.filter('formattedDateTime', function (date) {
    let formatDate = moment(date).format('DD.MM.YYYY HH:mm')

    if (formatDate == 'Invalid date') return "Не указана"
    return formatDate
})

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value
    }
    let formatter = new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 0,
		maximumFractionDigits: 2
    })
    return formatter.format(value)
})
Vue.filter('toShortCurrency', function (value) {
    if (typeof value !== "number") {
        return value
    }
    let formatter = new Intl.NumberFormat('ru-RU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    })
    return formatter.format(value)
})

import '@/mixins/helpersFunctions'
import './utils/tableSettingsSync'

const app = new Vue({
    el: '#app',
    store,
    router: routes,
    mounted() {
        // Инициализируем сервис проверки версии после монтирования приложения
        if (store.getters['auth/isAuthenticated']) {
            versionService.init()
            
            // Инициализируем и синхронизируем настройки таблиц с БД
            store.dispatch('userLocalSettings/INITIALIZE_AND_SYNC')
        }
    }
})

// Add axios interceptor for handling 401 responses
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            store.dispatch('auth/AUTH_LOGOUT');
            
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

// Add periodic user status check
if (store.getters['auth/isAuthenticated']) {
    // Check user status every 5 minutes
    setInterval(() => {
        store.dispatch('auth/checkUserStatus');
    }, 5 * 60 * 1000);
}
